export const iconList = [
  { name: "mail", url: "../assets/icons/ic_mail.svg" },
  { name: "password", url: "../assets/icons/ic_password.svg" },
  { name: "google", url: "../assets/logo/google_logo.svg" },
  { name: "facebook", url: "../assets/logo/facebook_logo.svg" },
  { name: "apple", url: "../assets/logo/apple_logo.svg" },
  { name: "select-company", url: "../assets/icons/ic_select_company.svg" },
  { name: "select-private", url: "../assets/icons/ic_select_private.svg" },
  { name: "phone", url: "../assets/icons/ic_phone.svg" },
  { name: "info", url: "../assets/icons/ic_info.svg" },
  { name: "iban", url: "../assets/icons/ic_iban.svg" },
  { name: "iban_account", url: "../assets/icons/ic_iban_account.svg" },
  { name: "pin", url: "../assets/icons/ic_pin.svg" },
  { name: "file", url: "../assets/icons/ic_file.svg" },
  { name: "shareholder", url: "../assets/icons/ic_shareholder.svg" },
  { name: "check", url: "../assets/icons/ic_check.svg" },
  { name: "error", url: "../assets/icons/ic_error.svg" },
  { name: "arrow-right", url: "../assets/icons/ic_arrow_right.svg" },
  { name: "yellow-arrow-right", url: "../assets/icons/ic_yellow_arrow_right.svg" },
  { name: "arrow-below", url: "../assets/icons/ic_arrow_below.svg" },
  { name: "img-euro", url: "../assets/image/img_euro.svg" },
  { name: "home", url: "../assets/icons/ic_home.svg" },
  { name: "home-selected", url: "../assets/icons/ic_home_selected.svg" },
  { name: "img-gold", url: "../assets/image/img_gold.svg" },
  { name: "img-silver", url: "../assets/image/img_silver.svg" },
  { name: "img-palladium", url: "../assets/image/img_palladium.svg" },
  { name: "img-platinium", url: "../assets/image/img_platinium.svg" },
  { name: "ic-euro", url: "../assets/icons/ic_euro.svg" },
  { name: "ic-au", url: "../assets/icons/ic_au.svg" },
  { name: "ic-ag", url: "../assets/icons/ic_ag.svg" },
  { name: "ic-pt", url: "../assets/icons/ic_pt.svg" },
  { name: "ic-pd", url: "../assets/icons/ic_pd.svg" },
  { name: "ic-buy", url: "../assets/icons/ic_buy.svg" },
  { name: "ic-saving-plan", url: "../assets/icons/ic_saving_plan.svg" },
  { name: "ic-saving-plan-selected", url: "../assets/icons/ic_saving_plan_selected.svg" },
  { name: "ic-vault", url: "../assets/icons/ic_vault.svg" },
  { name: "ic-vault-selected", url: "../assets/icons/ic_vault_selected.svg" },
  { name: "ic-sell", url: "../assets/icons/ic_sell.svg" },
  { name: "ic-change", url: "../assets/icons/ic_change.svg" },
  { name: "ic-send", url: "../assets/icons/ic_send.svg" },
  { name: "ic-profile", url: "../assets/icons/ic_profile.svg" },
  { name: "ic-profile-selected", url: "../assets/icons/ic_profile_selected.svg" },
  { name: "ic-shop", url: "../assets/icons/ic_shop.svg" },
  { name: "ic-shop-selected", url: "../assets/icons/ic_shop_selected.svg" },
  { name: "ic-transaction", url: "../assets/icons/ic_transaction.svg" },
  { name: "ic-transaction-selected", url: "../assets/icons/ic_transaction_selected.svg" },
  { name: "ic-basket", url: "../assets/icons/ic_basket.svg" },
  { name: "ic-filter", url: "../assets/icons/ic_filter.svg" },
  { name: "ic-plus", url: "../assets/icons/ic_plus.svg" },
  { name: "ic-notification", url: "../assets/icons/ic_notification.svg" },
  { name: "ic-notification-selected", url: "../assets/icons/ic_notification_selected.svg" },
  { name: "ic-contact", url: "../assets/icons/ic_contact.svg" },
  { name: "ic-contact-selected", url: "../assets/icons/ic_contact_selected.svg" },
  { name: "ic-settings", url: "../assets/icons/ic_settings.svg" },
  { name: "ic-settings-selected", url: "../assets/icons/ic_settings_selected.svg" },
  { name: "ic-minus", url: "../assets/icons/ic_minus.svg" },
  { name: "ic-location", url: "../assets/icons/ic_location.svg" },
  { name: "ic-cargo", url: "../assets/icons/ic_cargo.svg" },
  { name: "ic-pay-euro", url: "../assets/icons/ic_pay_euro.svg" },
  { name: "ic-paypal", url: "../assets/icons/ic_paypal.svg" },
  { name: "ic-credit-card", url: "../assets/icons/ic_credit_card.svg" },
  { name: "ic-paysafe", url: "../assets/icons/ic_paysafe.svg" },
  { name: "ic-sync", url: "../assets/icons/ic_sync.svg" },
  { name: "ic-wallet", url: "../assets/icons/ic_wallet.svg" },
  { name: "ic-wallet-selected", url: "../assets/icons/ic_wallet_selected.svg" },
  { name: "ic-right", url: "../assets/icons/ic_right.svg" },
  { name: "ic-warning", url: "../assets/icons/ic_warning.svg" },
  { name: "ic-calender", url: "../assets/icons/ic_calender.svg" },
  { name: "ic-package", url: "../assets/icons/ic_package" },
  { name: "ic-notification-item", url: "../assets/icons/ic_notification_item" },
  { name: "ic-edit", url: "../assets/icons/ic_edit.svg" },
  { name: "ic-vault-shipment", url: "../assets/icons/ic_vault_shipment.svg" },
  {name:"ic-delete", url:"../assets/icons/ic_delete.svg"},
  {name:"ic-flag-en", url:"../assets/icons/ic_flag_en.svg"},
  {name:"ic-flag-nl", url:"../assets/icons/ic_flag_nl.svg"},
  {name:"ic-flag-de", url:"../assets/icons/ic_flag_de.svg"},
  {name:"pin-bold", url:"../assets/icons/ic_pin_bold.svg"},
  {name:"phone-bold", url:"../assets/icons/ic_phone_bold.svg"},
  {name:"ic-warning-mark", url:"../assets/icons/ic_warning_mark.svg"},
  {name:"ic-arrow-down-white", url:"../assets/icons/ic_arrow_down_white.svg"},
  { name: "arrow-right-black", url: "../assets/icons/ic_arrow_right_black.svg" },
  { name: "ic-goldcard", url: "../assets/icons/ic_goldcard.svg" },
  { name: "right_arrow_yellow_full", url: "../assets/icons/ic_right_arrow_yellow_full.svg" },
  { name: "ic-wallet-amount", url: "../assets/icons/ic_wallet_amount.svg" },
];
